module.exports = __webpack_public_path__ + "img/nomadswork-logo@2x.89eee390.png";